<div class="input-field" *transloco="let t">

    <label class="input-field__label" [for]="fieldId">{{ t(fieldLabel) }}</label>

    <p-multiSelect
      #multiSelectComponent
      [id]="fieldId"
      class="input"
      [showToggleAll]="false"
      optionLabel="username"
      dataKey="id"
      [resetFilterOnHide]="true"
      [group]="true"
      [options]="groupedOptions"
      [(ngModel)]="selectedItems"
      [filterValue]="filterValue"
      [styleClass]="testClass"
      [selectionLimit]="1"
      (onChange)="onSelect($event)"
      (onFilter)="onFilter($event)"
      (onPanelShow)="observeFilterchanges()"
      (onPanelHide)="cleanUpPanel()"
    >

      <ng-template let-group pTemplate="group">
        <span>{{ t(group.label) }}</span>
      </ng-template>

      <ng-template let-value pTemplate="selectedItems">
        <!-- Placeholder to maintain input height before and after selecting an option -->
        <div style="opacity: 0" [transloco]="fieldLabel"></div>
      </ng-template>

      <ng-template let-user pTemplate="item">
        <bulb-unit-chip [unit]="user"></bulb-unit-chip>
        <div style="color: transparent"
          *ngIf="!pageState.isLast && (groupedOptions[1].items | isLastByKey:user:'id')"
          bulbRunInView
          (enterView)="loadMore(filterValue)"
        >{{ t('sharePanel.search.loading') }}</div>
      </ng-template>

      <ng-template pTemplate="footer">
        <p class="results-footer" *ngIf="filterValue !== '' && groupedOptions[1].items | isEmpty">
          {{ t('sharePanel.search.noResults') }}
        </p>
      </ng-template>

    </p-multiSelect>

</div>
